var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreen = function SvgScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 4H4C1.792 4 0 5.792 0 8v26.667c0 2.208 1.792 4 4 4h16l-1.333 4h-6c-1.109 0-2 .891-2 2 0 1.108.891 2 2 2h22.666c1.109 0 2-.892 2-2 0-1.109-.891-2-2-2h-6l-1.333-4h16c2.208 0 4-1.792 4-4V8c0-2.208-1.792-4-4-4zm-1.333 29.333H5.333v-24h37.334v24z"
  })));
};
export default SvgScreen;